import { useCallback, useContext, useState } from 'react';

import { Button } from 'antd';

import Message from '@/components/chat/Message';
import { FormGroupContext } from '@/components/FormGroup';
import TextAnswer from '@/components/wizard/TextAnswer';
import { validateFields } from '@/lib/validation';
import useStepStore from '@/stores/steps';

type FieldsProps = {
  awaitOnAnswer?: (answer: string[]) => Promise<void>;
};

const Fields = ({ awaitOnAnswer }: FieldsProps) => {
  const { emit } = useContext(FormGroupContext);
  const nextStep = useStepStore(({ nextStep }) => nextStep);
  const [selectionText, setSelectionText] = useState<string>('');

  const submit = useCallback(async () => {
    const results = await emit({ type: 'validate' });
    nextStep({
      validate: () => {
        const isValid = validateFields(results);

        if (!isValid) {
          return false;
        }

        awaitOnAnswer?.([results['answer']]);
        setSelectionText(results['answer']);
        return true;
      }
    });
  }, [emit, nextStep, awaitOnAnswer]);

  if (selectionText) {
    return <Message type='answer'>{selectionText}</Message>;
  }

  return (
    <div className='mt-4 mb-28 flex flex-col gap-4'>
      <TextAnswer />

      <Button className='mt-4! w-full! rounded-lg!' id='confirm-selection-button' onClick={submit}>
        Confirmar resposta
      </Button>
    </div>
  );
};

export default Fields;
